import { render, staticRenderFns } from "./DialogPop.vue?vue&type=template&id=3c2f7c40&scoped=true&"
import script from "./DialogPop.vue?vue&type=script&lang=js&"
export * from "./DialogPop.vue?vue&type=script&lang=js&"
import style0 from "./DialogPop.vue?vue&type=style&index=0&id=3c2f7c40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f7c40",
  null
  
)

export default component.exports